import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = ({ theme }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const baseStyles = theme === 'tech'
        ? {
            background: 'rgba(0, 255, 0, 0.1)',
            textColor: 'text-green-400',
            borderColor: 'border-green-400',
            hoverBg: 'hover:bg-green-400',
            hoverText: 'hover:text-black'
        }
        : {
            background: 'rgba(52, 152, 219, 0.1)',
            textColor: 'text-blue-500',
            borderColor: 'border-blue-500',
            hoverBg: 'hover:bg-blue-500',
            hoverText: 'hover:text-white'
        };

    const navItems = [
        { name: 'Home', path: '/' },
        { name: 'Our Team', path: '/team' },
        { name: 'Contact', path: '/contact' }
    ];

    return (
        <nav className="relative">
            {/* Desktop Navigation */}
            <div className="hidden md:flex justify-center items-center px-8 py-4 mt-8">
                <div className="flex space-x-12">
                    {navItems.map(({ name, path }) => (
                        <Link
                            key={name}
                            to={path}
                            className={`
                relative px-4 py-2
                font-medium text-lg rounded-md
                ${baseStyles.textColor}
                ${baseStyles.hoverBg}
                ${baseStyles.hoverText}
                transition-all duration-200
                hover:scale-105
              `}
                        >
                            {name}
                        </Link>
                    ))}
                </div>
            </div>

            {/* Mobile Navigation */}
            <div className="md:hidden">
                {/* Hamburger Button */}
                <button
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    className={`
            fixed top-4 right-16 z-50 p-2 rounded-lg  /* Moved right to make space for theme toggle */
            ${baseStyles.borderColor} border
            ${baseStyles.textColor}
            backdrop-blur-sm
          `}
                >
                    {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>

                {/* Mobile Menu Overlay */}
                <div
                    className={`
            fixed inset-0 z-40
            backdrop-blur-md bg-black/50
            transition-opacity duration-300
            ${isMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}
          `}
                    onClick={() => setIsMenuOpen(false)}
                />

                {/* Mobile Menu Drawer */}
                <div
                    className={`
            fixed top-0 right-0 bottom-0
            w-64 z-[45]  /* Adjusted z-index */
            bg-black/90 backdrop-blur-sm
            transform transition-transform duration-300 ease-in-out
            ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}
            ${theme === 'tech' ? 'border-l border-green-400/30' : 'border-l border-blue-500/30'}
          `}
                >
                    <div className="flex flex-col pt-20 px-4 space-y-4">
                        {navItems.map(({name, path}) => (
                            <Link
                                key={name}
                                to={path}
                                onClick={() => setIsMenuOpen(false)}
                                className={`
                  px-4 py-3 rounded-lg
                  font-medium text-lg
                  ${baseStyles.textColor}
                  ${theme === 'tech' ? 'hover:bg-green-400/10' : 'hover:bg-blue-500/10'}
                  transition-colors duration-200
                `}
                            >
                                {name}
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navigation;